import React from 'react';

const ModalAccount = ({ logoimg, linelink, onClose, checkurl }) => {
    return (
        <div className="base-modal-overlay x-modal modal -v2 x-theme-switcher-v2 show animated animatedFadeInUp fadeInUp "
            data-v-0c0c7fd4=""
        >
            <div
                className="base-modal pt-0 pb-0 w-100"
                data-v-8bc7c3b9=""
                style={{ margin: 10, textAlign: "-webkit-center" }}
            >
                <div
                    className="modal-dialog -modal-size -v2 modal-dialog-centered modal-dialog-scrollable modal-dialog-centered w-100 m-0"
                    data-v-8bc7c3b9=""
                    style={{ height: "auto" }}
                >
                    <div
                        className="modal-content -modal-content text-white-v1"
                        data-v-8bc7c3b9=""
                    >
                        <a href="/"
                            role="button"
                            className="close-model-head mt-4 mb-4"
                            data-v-8bc7c3b9=""
                            onClick={(e) => {
                                onClose();
                            }}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={30}
                                height={30}
                                fill="currentColor"
                                className="bi bi-x-circle-fill"
                                viewBox="0 0 16 16"
                                data-v-8bc7c3b9=""
                            >
                                <path
                                    d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"
                                    data-v-8bc7c3b9=""
                                />
                            </svg>
                        </a>

                        <div
                            className="pt-3 pb-4 x-theme-switcher-v2 text-center mt-3"
                            data-v-8bc7c3b9=""
                        >
                            <div className="-inner-header-section" data-v-8bc7c3b9="">
                                <img
                                    src={logoimg}
                                    alt=""
                                    data-v-8bc7c3b9=""
                                    style={{ width: 160 }}
                                />
                                <div className="mt-1 mb-1 w-100" data-v-8bc7c3b9="" style={{ marginTop: "-30px" }}>
                                    <h3 className="title-footer-wrap pt-2">
                                        <b>Language / ภาษา </b>
                                    </h3>
                                    <ul className="logo-list-footer">
                                        <li role="button">
                                            <img
                                                className="lang-img active-lang"
                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8e1626da-cc1f-451f-838f-54e5e1848f00/public"
                                                alt=""
                                            />
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div
                                className="row -inner-center-body-section m-0"
                                data-v-8bc7c3b9=""
                            >
                                <div className="col-6 -wrapper-box" data-v-8bc7c3b9="">
                                    <a
                                        role="button"
                                        className="btn -btn-item -event-button -menu-center -horizontal"
                                        data-v-8bc7c3b9=""
                                        onClick={(e) => {
                                            checkurl(e, "/profile")
                                        }}
                                    >
                                        <picture data-v-8bc7c3b9="">
                                            <source
                                                type="image/webp"
                                                data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/3066ed62-07f3-4623-b4c0-ac1d1eb7e300/public"
                                                srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/3066ed62-07f3-4623-b4c0-ac1d1eb7e300/public"
                                                data-v-8bc7c3b9=""
                                            />
                                            <source
                                                type="image/png?v=1"
                                                data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/3066ed62-07f3-4623-b4c0-ac1d1eb7e300/public"
                                                srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/3066ed62-07f3-4623-b4c0-ac1d1eb7e300/public"
                                                data-v-8bc7c3b9=""
                                            />
                                            <img alt=""
                                                className="img-fluid -icon-image ls-is-cached lazyloaded"
                                                data-src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/3066ed62-07f3-4623-b4c0-ac1d1eb7e300/public"
                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/3066ed62-07f3-4623-b4c0-ac1d1eb7e300/public"
                                                data-v-8bc7c3b9=""
                                            />
                                        </picture>
                                        <div className="-typo-wrapper" data-v-8bc7c3b9="">
                                            <div className="-typo -is-logged" data-v-8bc7c3b9="">
                                                <span data-v-8bc7c3b9="">ข้อมูลบัญชี</span>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                <div className="col-6 -wrapper-box" data-v-8bc7c3b9="">
                                    <a 
                                        onClick={(e) => {
                                            checkurl(e, "/loss")
                                        }}
                                        role="button"
                                        className="btn -btn-item -event-button -menu-center -horizontal"
                                        data-v-8bc7c3b9=""
                                    >
                                        <picture data-v-8bc7c3b9="">
                                            <source
                                                type="image/webp"
                                                data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/5ab912d5-9d59-4e39-f3fa-f108d3d62500/public"
                                                srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/5ab912d5-9d59-4e39-f3fa-f108d3d62500/public"
                                                data-v-8bc7c3b9=""
                                            />
                                            <source
                                                type="image/png?v=1"
                                                data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/5ab912d5-9d59-4e39-f3fa-f108d3d62500/public"
                                                srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/5ab912d5-9d59-4e39-f3fa-f108d3d62500/public"
                                                data-v-8bc7c3b9=""
                                            />
                                            <img alt=""
                                                className="img-fluid -icon-image ls-is-cached lazyloaded"
                                                data-src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/5ab912d5-9d59-4e39-f3fa-f108d3d62500/public"
                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/5ab912d5-9d59-4e39-f3fa-f108d3d62500/public"
                                                data-v-8bc7c3b9=""
                                            />
                                        </picture>
                                        <div className="-typo-wrapper" data-v-8bc7c3b9="">
                                            <div className="-typo -is-logged" data-v-8bc7c3b9="">
                                                <span data-v-8bc7c3b9="">คืนยอดเสีย</span>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                <div className="col-6 -wrapper-box" data-v-8bc7c3b9="">
                                    <a
                                        onClick={(e) => {
                                            checkurl(e, "/refer/overview")
                                        }}
                                        role="button"
                                        className="btn -btn-item -event-button -menu-center -horizontal"
                                        data-v-8bc7c3b9=""
                                    >
                                        <picture data-v-8bc7c3b9="">
                                            <source
                                                type="image/webp"
                                                data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8497de75-3140-4e19-9747-a03adb7c7700/public"
                                                srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8497de75-3140-4e19-9747-a03adb7c7700/public"
                                                data-v-8bc7c3b9=""
                                            />
                                            <source
                                                type="image/png?v=1"
                                                data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8497de75-3140-4e19-9747-a03adb7c7700/public"
                                                srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8497de75-3140-4e19-9747-a03adb7c7700/public"
                                                data-v-8bc7c3b9=""
                                            />
                                            <img alt=""
                                                className="img-fluid -icon-image ls-is-cached lazyloaded"
                                                data-src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8497de75-3140-4e19-9747-a03adb7c7700/public"
                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8497de75-3140-4e19-9747-a03adb7c7700/public"
                                                data-v-8bc7c3b9=""
                                            />
                                        </picture>
                                        <div className="-typo-wrapper" data-v-8bc7c3b9="">
                                            <div className="-typo -is-logged" data-v-8bc7c3b9="">
                                                <span data-v-8bc7c3b9="">เเนะนำเพื่อน</span>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                <div className="col-6 -wrapper-box" data-v-8bc7c3b9="">
                                    <a 
                                        onClick={(e) => {
                                            checkurl(e, "/statement")
                                        }}
                                        role="button"
                                        className="btn -btn-item -event-button -menu-center -horizontal"
                                        data-v-8bc7c3b9=""
                                    >
                                        <picture data-v-8bc7c3b9="">
                                            <source
                                                type="image/webp"
                                                data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/a2075ee6-ea48-47ed-726b-01a8b6ec8000/public"
                                                srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/a2075ee6-ea48-47ed-726b-01a8b6ec8000/public"
                                                data-v-8bc7c3b9=""
                                            />
                                            <source
                                                type="image/png?v=1"
                                                data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/a2075ee6-ea48-47ed-726b-01a8b6ec8000/public"
                                                srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/a2075ee6-ea48-47ed-726b-01a8b6ec8000/public"
                                                data-v-8bc7c3b9=""
                                            />
                                            <img alt=""
                                                className="img-fluid -icon-image ls-is-cached lazyloaded"
                                                data-src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/a2075ee6-ea48-47ed-726b-01a8b6ec8000/public"
                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/a2075ee6-ea48-47ed-726b-01a8b6ec8000/public"
                                                data-v-8bc7c3b9=""
                                            />
                                        </picture>
                                        <div className="-typo-wrapper" data-v-8bc7c3b9="">
                                            <div className="-typo -is-logged" data-v-8bc7c3b9="">
                                                <span data-v-8bc7c3b9="">ประวัติ</span>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                <div className="col-6 -wrapper-box" data-v-8bc7c3b9="">
                                    <a 
                                        onClick={(e) => {
                                            checkurl(e, "/promotion")
                                        }}
                                        role="button"
                                        className="btn -btn-item -event-button -menu-center -horizontal"
                                        data-v-8bc7c3b9=""
                                    >
                                        <picture data-v-8bc7c3b9="">
                                            <source
                                                type="image/webp"
                                                data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8e8bbd6d-2594-4c50-3863-029c7e9a3500/public"
                                                srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8e8bbd6d-2594-4c50-3863-029c7e9a3500/public"
                                                data-v-8bc7c3b9=""
                                            />
                                            <source
                                                type="image/png?v=1"
                                                data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8e8bbd6d-2594-4c50-3863-029c7e9a3500/public"
                                                srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8e8bbd6d-2594-4c50-3863-029c7e9a3500/public"
                                                data-v-8bc7c3b9=""
                                            />
                                            <img alt=""
                                                className="img-fluid -icon-image ls-is-cached lazyloaded"
                                                data-src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8e8bbd6d-2594-4c50-3863-029c7e9a3500/public"
                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/8e8bbd6d-2594-4c50-3863-029c7e9a3500/public"
                                                data-v-8bc7c3b9=""
                                            />
                                        </picture>
                                        <div className="-typo-wrapper" data-v-8bc7c3b9="">
                                            <div className="-typo -is-logged" data-v-8bc7c3b9="">
                                                <span data-v-8bc7c3b9="">โปรโมชั่น</span>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                                {/* <div className="col-6 -wrapper-box" data-v-8bc7c3b9="">
                  <a
                   href='/promotion'
                    role="button"
                    className="btn -btn-item -event-button -menu-center -horizontal"
                    data-v-8bc7c3b9=""
                  >
                    <picture data-v-8bc7c3b9="">
                      <source
                        type="image/webp"
                        data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/6311559f-81fe-484a-ea3e-30b9d40fb700/public"
                        srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/6311559f-81fe-484a-ea3e-30b9d40fb700/public"
                        data-v-8bc7c3b9=""
                      />
                      <source
                        type="image/png?v=1"
                        data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/6311559f-81fe-484a-ea3e-30b9d40fb700/public"
                        srcSet="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/6311559f-81fe-484a-ea3e-30b9d40fb700/public"
                        data-v-8bc7c3b9=""
                      />
                      <img alt=""
                        className="img-fluid -icon-image ls-is-cached lazyloaded"
                        data-src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/6311559f-81fe-484a-ea3e-30b9d40fb700/public"
                        src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/6311559f-81fe-484a-ea3e-30b9d40fb700/public"
                        data-v-8bc7c3b9=""
                      />
                    </picture>
                    <div className="-typo-wrapper" data-v-8bc7c3b9="">
                      <div className="-typo -is-logged" data-v-8bc7c3b9="">
                        <span data-v-8bc7c3b9="">เเลกของรางวัล</span>
                      </div>
                    </div>
                  </a>
                </div> */}

                                <div className="col-6 -wrapper-box" data-v-8bc7c3b9="">
                                    <a
                                        href="/logout"
                                        role="button"
                                        className="btn -btn-item -event-button -menu-center -horizontal"
                                        data-v-8bc7c3b9=""
                                    >
                                        <picture data-v-8bc7c3b9="">
                                            <source
                                                type="image/webp"
                                                data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/630a8cf7-f7a8-4ff3-0e58-0b9929ce5500/public"
                                                srcSet="
                  https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/630a8cf7-f7a8-4ff3-0e58-0b9929ce5500/public
                "
                                                data-v-8bc7c3b9=""
                                            />
                                            <source
                                                type="image/png?v=1"
                                                data-srcset="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/630a8cf7-f7a8-4ff3-0e58-0b9929ce5500/public"
                                                srcSet="
                  https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/630a8cf7-f7a8-4ff3-0e58-0b9929ce5500/public
                "
                                                data-v-8bc7c3b9=""
                                            />
                                            <img alt=""
                                                className="img-fluid -icon-image ls-is-cached lazyloaded"
                                                data-src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/630a8cf7-f7a8-4ff3-0e58-0b9929ce5500/public"
                                                src="https://imagedelivery.net/g1yWpHq5ZqQxQIXvcCDaOA/630a8cf7-f7a8-4ff3-0e58-0b9929ce5500/public"
                                                data-v-8bc7c3b9=""
                                            />
                                        </picture>
                                        <div className="-typo-wrapper" data-v-8bc7c3b9="">
                                            <div className="-typo -is-logged" data-v-8bc7c3b9="">
                                                ออกจากระบบ
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                            <br data-v-8bc7c3b9="" />
                            <br data-v-8bc7c3b9="" />
                            <br data-v-8bc7c3b9="" />
                            <br data-v-8bc7c3b9="" />
                            <br data-v-8bc7c3b9="" />
                            <br data-v-8bc7c3b9="" />
                            <br data-v-8bc7c3b9="" />
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default ModalAccount;
